<template>
  <vSelect
    :clearable="clearable"
    :options="options"
    :filterable="false"
    label="name"
    :loading="loading"
    :placeholder="placeholder"
    @open="onOpen"
    @close="onClose"
    @search="debouncedHandleSearch"
    @input="handleSelectedValue"
    v-model="selectedValue"
  >
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">
        Loading more options...
      </li>
    </template>
  </vSelect>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import debounce from 'lodash-es/debounce'

export default {
  props: ['apiUrl', 'clearable', 'value', 'placeholder', 'optionsMapper'],
  name: 'UISelectPaginated',
  components: {
    vSelect,
  },
  data() {
    return {
      observer: null,
      pageSize: 20,
      page: 0,
      search: '',
      loading: true,
      options: [],
      totalCount: 0,
      selectedValue: this.value,
    }
  },
  computed: {
    hasNextPage: function () {
      return this.options.length < this.totalCount
    },
    debouncedHandleSearch() {
      return debounce(this.handleSearch, 800)
    },
  },
  watch: {
    search: async function () {
      this.loading = true
      this.page = 0
      this.options = []
      await this.fetchOptions()
      this.attachObserver()
      this.loading = false
    },
    selectedValue(newValue) {
      this.$emit('input', newValue)
    },
    value(changedValue) {
      this.selectedValue = changedValue
    },
  },
  mounted() {
    this.loading = true
    this.page = 0
    this.options = []
    this.fetchOptions()
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.loading = false
  },
  methods: {
    async fetchDataFromApi(page, pageSize, search = '') {
      try {
        const response = await axios.get(this.apiUrl, {
          params: {
            limit: pageSize,
            offset: page * pageSize,
            search: search || '',
          },
        })
        return response?.data
      } catch (error) {
        console.error('Error fetching options:', error)
      }
    },
    async fetchOptions() {
      try {
        const data = await this.fetchDataFromApi(
          this.page,
          this.pageSize,
          this.search
        )

        if(!data) {
          return
        }
        const newOptions = this.optionsMapper ? this.optionsMapper(data.rows) : data.rows
        this.options = [...this.options, ...newOptions]
        this.totalCount = data.count
      } catch (error) {
        console.error('Error fetching options:', error)
      }
    },
    async onOpen() {
      await this.attachObserver()
    },
    onClose() {
      this.observer.disconnect()
    },
    async handleSearch(searchQuery) {
      this.search = searchQuery
    },
    async attachObserver() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.page += 1
        await this.$nextTick()
        await this.fetchOptions()
        ul.scrollTop = scrollTop
      }
    },
    handleSelectedValue(value) {
      this.selectedValue = value
    },
  },
}
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
